import { jsx as o, jsxs as y, Fragment as N } from "react/jsx-runtime";
import { z as t } from "zod";
import { useImageProcessor as S } from "@made-people/grease-image";
import { withZod as c } from "@made-people/react-prop-guard";
import { isNotUndefined as I } from "@made-people/typeguards-common";
import { forwardRef as j } from "react";
import { withManagedProps as W } from "@made-people/managed-props";
import k from "clsx";
import { ImageIcon as p } from "@made-people/blueprint-icons";
function O(e, n) {
  let i;
  return n === "mobile" ? i = e.mobile ?? e.tablet ?? e.desktop : n === "tablet" ? i = e.tablet ?? e.mobile ?? e.desktop : i = e.desktop ?? e.tablet ?? e.mobile, i;
}
function w(e) {
  return ["mobile", "tablet", "desktop"].map(
    (n) => O(
      e,
      n
    )
  ).filter(I);
}
const s = t.object({
  src: t.string(),
  width: t.number().optional(),
  height: t.number().optional(),
  alt: t.string().nullable().optional()
});
function D(e) {
  if (e.minWidth && e.maxWidth) {
    if (e.minWidth > e.maxWidth)
      throw new Error("minWidth must be less than maxWidth");
    return `(min-width: ${e.minWidth}px) and (max-width: ${e.maxWidth}px)`;
  } else
    return e.minWidth ? `(min-width: ${e.minWidth}px)` : e.maxWidth ? `(max-width: ${e.maxWidth}px)` : "";
}
function F(e, n, i, a) {
  return n.map(
    (l) => `${i(e, { ...a, width: l })} ${l}w`
  );
}
function R(e, n, i, a) {
  return F(e, n, i, a).join(", ");
}
const z = t.object({
  format: t.enum(["webp", "jpeg", "png", "svg", "auto"]).optional(),
  quality: t.number().optional(),
  gravity: t.union([
    t.literal("left"),
    t.literal("right"),
    t.literal("top"),
    t.literal("bottom"),
    t.object({ x: t.number(), y: t.number() })
  ]).optional()
}), $ = t.object({
  widths: t.number().array().describe("Array of widths for the image."),
  sizes: t.string().describe("'sizes' attribute for the image.")
}), P = t.object({
  maxWidth: t.number().optional(),
  minWidth: t.number().optional()
}), d = t.object({
  image: s,
  srcSet: $,
  alt: t.string().optional(),
  breakpoints: P,
  processingOptions: z.optional()
}), B = c(
  d,
  (e) => {
    const n = S();
    return /* @__PURE__ */ o(
      "source",
      {
        media: D(e.breakpoints),
        sizes: e.srcSet.sizes,
        srcSet: R(
          e.image.src,
          e.srcSet.widths,
          n,
          e.processingOptions
        )
      }
    );
  }
), h = t.object({
  mobile: d.optional(),
  tablet: d.optional(),
  desktop: d.optional(),
  children: t.custom(),
  className: t.string().optional(),
  style: t.custom().optional()
}), M = c(
  h,
  (e) => /* @__PURE__ */ y("picture", { className: e.className, style: e.style, children: [
    w(e).map((n, i) => /* @__PURE__ */ o(B, { ...n }, i)),
    e.children
  ] })
), A = (e, n, i) => {
  const a = e.srcSet.widths, l = i ?? a[Math.floor(a.length / 2)];
  return n(e.image.src, {
    ...e.processingOptions,
    width: l
  });
}, q = t.object({
  sources: h,
  width: t.number().optional(),
  alt: t.string(),
  className: t.string().optional(),
  loading: t.enum(["eager", "lazy"]).optional(),
  fetchpriority: t.enum(["high", "low", "auto"]).optional()
}), E = c(q, (e) => {
  const n = S(), i = w(e.sources)[0];
  if (!i)
    return null;
  const a = A(i, n, e.width);
  return /* @__PURE__ */ o(
    "img",
    {
      src: a,
      style: {
        objectFit: "inherit",
        objectPosition: "inherit",
        height: "100%",
        width: "100%",
        display: "inherit"
      },
      alt: e.alt,
      loading: (e == null ? void 0 : e.loading) ?? "lazy",
      fetchpriority: (e == null ? void 0 : e.fetchpriority) ?? "auto"
    }
  );
}), v = t.object({
  caption: t.string().optional(),
  children: t.custom(),
  className: t.string().optional(),
  style: t.custom().optional()
}), L = c(
  v,
  (e) => e.caption ? /* @__PURE__ */ y("figure", { className: e.className, style: e.style, children: [
    e.children,
    /* @__PURE__ */ o("figcaption", { children: e.caption })
  ] }) : /* @__PURE__ */ o(N, { children: e.children })
), Q = t.object({
  sources: h,
  figure: v.optional(),
  alt: t.string(),
  style: t.custom().optional(),
  className: t.string().optional(),
  loading: t.enum(["eager", "lazy"]).optional(),
  fetchpriority: t.enum(["high", "low", "auto"]).optional()
}), T = W(
  "ResponsiveImageBase",
  c(
    Q,
    j(
      (e, n) => {
        var i, a;
        return /* @__PURE__ */ o(
          L,
          {
            caption: (i = e.figure) == null ? void 0 : i.caption,
            className: (a = e.figure) != null && a.caption ? e.className : "",
            style: e.style,
            children: /* @__PURE__ */ o(
              M,
              {
                ...e.sources,
                className: e.className,
                style: e.style,
                children: /* @__PURE__ */ o(
                  E,
                  {
                    sources: e.sources,
                    alt: e.alt,
                    className: e.className,
                    loading: e == null ? void 0 : e.loading,
                    fetchpriority: e == null ? void 0 : e.fetchpriority
                  }
                )
              }
            )
          }
        );
      }
    )
  )
), U = (e) => {
  const n = e.initial || e.image, i = e.md || e.tabletImage, a = e.lg || e.desktopImage;
  return {
    image: n,
    tabletImage: i,
    desktopImage: a
  };
}, Z = (e, n) => {
  const { image: i, tabletImage: a, desktopImage: l } = n;
  if (!i)
    return;
  let r = "", m = "", g = "";
  typeof e.displaySize == "string" ? (r = e.displaySize, m = e.displaySize, g = e.displaySize) : typeof e.displaySize == "object" && e.displaySize !== null && (r = e.displaySize.mobile || e.displaySize.tablet || e.displaySize.desktop || "50vw", m = e.displaySize.tablet || e.displaySize.desktop || e.displaySize.mobile || "35vw", g = e.displaySize.desktop || e.displaySize.tablet || e.displaySize.mobile || "25vw");
  const u = (x) => {
    const f = x.match(/(\d+)vw/);
    if (f) {
      const b = parseInt(f[1] ?? "50vw", 10);
      return b <= 30 ? [100, 300, 600, 900, 1200] : b <= 60 ? [400, 600, 1e3, 1400, 1800] : [800, 1200, 1600, 2e3, 2400];
    }
    return [400, 800, 1200, 1600];
  };
  return {
    mobile: {
      image: i || a || l || void 0,
      processingOptions: e.processingOptions,
      alt: (i == null ? void 0 : i.alt) || (a == null ? void 0 : a.alt) || (l == null ? void 0 : l.alt) || "",
      srcSet: {
        widths: u(r),
        sizes: r
      },
      breakpoints: {
        maxWidth: 768
      }
    },
    tablet: {
      image: a || i || l || void 0,
      processingOptions: e.processingOptions,
      alt: (a == null ? void 0 : a.alt) || (i == null ? void 0 : i.alt) || (l == null ? void 0 : l.alt) || "",
      srcSet: {
        widths: u(m),
        sizes: m
      },
      breakpoints: {
        minWidth: 769,
        maxWidth: 1023
      }
    },
    desktop: {
      image: l || a || i || void 0,
      processingOptions: e.processingOptions,
      alt: (l == null ? void 0 : l.alt) || (a == null ? void 0 : a.alt) || (i == null ? void 0 : i.alt) || "",
      srcSet: {
        widths: u(g),
        sizes: g
      },
      breakpoints: {
        minWidth: 1024
      }
    }
  };
}, C = t.object({
  className: t.string().optional(),
  /**
   * @deprecated Please avoid using 'image' going forward. Use 'initial' instead.
   */
  image: s.optional().nullable(),
  /**
   * @deprecated Please avoid using 'image' going forward. Use 'md' instead.
   */
  tabletImage: s.optional().nullable(),
  /**
   * @deprecated Please avoid using 'image' going forward. Use 'lg' instead.
   */
  desktopImage: s.optional().nullable(),
  style: t.custom().optional(),
  /**
   * The img loading attribute, use 'eager' for LCP content.
   */
  loading: t.enum(["eager", "lazy"]).optional(),
  /**
   * Fetchpriority, use 'high' for LCP content.
   */
  fetchpriority: t.enum(["high", "low", "auto"]).optional(),
  /**
   * The main image to display. This is the image that will be displayed on mobile and up
   */
  initial: s.optional().nullable(),
  /**
   * The image to display on tablet and up
   */
  md: s.optional().nullable(),
  /**
   * The image to display on desktop and up
   */
  lg: s.optional().nullable(),
  displaySize: t.union([
    t.string(),
    t.object({
      mobile: t.string().optional(),
      tablet: t.string().optional(),
      desktop: t.string().optional()
    })
  ]).optional(),
  caption: t.string().optional(),
  processingOptions: z.optional()
}), ie = c(C, (e) => {
  const n = U(e);
  if (!n.image)
    return /* @__PURE__ */ o(
      "div",
      {
        className: k(
          e.className,
          "bg-black bg-neutral-100 rounded-sm flex justify-center items-center"
        ),
        children: /* @__PURE__ */ o(p, { className: "size-full max-h-6 max-w-6 opacity-15" })
      }
    );
  const i = Z(e, n);
  return i ? /* @__PURE__ */ o(
    T,
    {
      sources: i,
      alt: n.image.alt ?? "",
      className: e.className,
      style: e.style,
      figure: { caption: e.caption },
      loading: e.loading,
      fetchpriority: e.fetchpriority,
      ...e
    }
  ) : (console.warn("No image found for responsive image during render"), null);
}), ne = (e, n) => {
};
export {
  E as FallbackImage,
  ie as ResponsiveImage,
  T as ResponsiveImageBase,
  L as ResponsiveImageFigure,
  B as ResponsiveImageSource,
  M as ResponsiveImageSources,
  q as fallbackImageSchema,
  A as getFallbackImageSrc,
  U as getImageDefinitions,
  O as getImageSourceForDevice,
  w as getImageSources,
  D as getMediaQuery,
  ne as getPreloadLinkAttributes,
  Z as getSources,
  F as getSrcset,
  R as getSrcsetString,
  s as imageTypeSchema,
  Q as responsiveImageBaseSchema,
  P as responsiveImageBreakpointsSchema,
  v as responsiveImageFigureSchema,
  z as responsiveImageProcessingOptionsSchema,
  C as responsiveImageSchema,
  d as responsiveImageSourceSchema,
  h as responsiveImageSourcesSchema,
  $ as responsiveImageSrcsetSchema
};
//# sourceMappingURL=index.es.js.map
